import { createActionGroup, emptyProps, props } from "@ngrx/store";
import {
    ManagedWorkflow,
    WorkflowSection,
    WorkflowStep,
    WorkflowStepDraft,
} from "../models/workflow.models";

export const WorkflowsActions = createActionGroup({
    source: "Workflows",
    events: {
        "Page Opened": emptyProps(),
        "Workflows Loaded": props<{ workflows: ManagedWorkflow[] }>(),
        "Workflows Load Failed": emptyProps(),
        "Workflow Selected": props<{ workflowId: string }>(),
        "Steps Loaded": props<{
            workflowId: string;
            steps: WorkflowStep[];
        }>(),
        "Steps Load Failed": props<{ workflowId: string }>(),
        "Workflow Query Changed": props<{ query: string }>(),
        "Step Query Changed": props<{ query: string }>(),
        "Section Changed": props<{ section: WorkflowSection }>(),
        "Preview Index Changed": props<{ index: number }>(),
        "Create Requested": props<{ title: string }>(),
        "Create Succeeded": props<{ workflow: ManagedWorkflow }>(),
        "Rename Requested": props<{
            workflow: ManagedWorkflow;
            title: string;
        }>(),
        "Rename Succeeded": props<{ workflow: ManagedWorkflow }>(),
        "Owner Update Requested": props<{
            workflow: ManagedWorkflow;
            owner: ManagedWorkflow["ownerInfo"];
        }>(),
        "Owner Update Succeeded": props<{ workflow: ManagedWorkflow }>(),
        "Delete Requested": props<{ workflowId: string }>(),
        "Delete Succeeded": props<{ workflowId: string }>(),
        "Create Step Requested": props<{
            workflow: ManagedWorkflow;
            draft: WorkflowStepDraft;
        }>(),
        "Create Step Succeeded": props<{
            workflow: ManagedWorkflow;
            step: WorkflowStep;
        }>(),
        "Update Step Requested": props<{
            workflow: ManagedWorkflow;
            step: WorkflowStep;
            draft: WorkflowStepDraft;
        }>(),
        "Update Step Succeeded": props<{
            workflow: ManagedWorkflow;
            step: WorkflowStep;
            originalStepId: string;
        }>(),
        "Delete Step Requested": props<{
            workflow: ManagedWorkflow;
            stepId: string;
        }>(),
        "Delete Step Succeeded": props<{
            workflow: ManagedWorkflow;
            stepId: string;
        }>(),
        "Reorder Steps Requested": props<{
            workflow: ManagedWorkflow;
            previousIndex: number;
            currentIndex: number;
        }>(),
        "Reorder Steps Succeeded": props<{ workflow: ManagedWorkflow }>(),
        "Mutation Failed": emptyProps(),
        "Mutation Status Cleared": emptyProps(),
    },
});
